import { useEffect, useState } from "react";
import axios from "axios";

// Fetch the actual ticket holder, not the third-party redeemer. No customer/transaction writes.
export default function usePawnerScreeningDetails(receiptNo, enabled = true) {
  const [state, setState] = useState({ receiptNo: "", customer: null, error: "" });
  useEffect(() => {
    if (!receiptNo || !enabled) return;
    const controller = new AbortController();
    axios.get("https://www.lianfoong.com/api/pawn-transactions/getPawnerDetails", {
      params: { oldReceiptNo: receiptNo }, withCredentials: true, signal: controller.signal,
    }).then(({ data }) => {
      if (!controller.signal.aborted) setState({ receiptNo, customer: data, error: data?.name ? "" : "Pawner name is missing; verify screening manually." });
    }).catch(() => {
      if (!controller.signal.aborted) setState({ receiptNo, customer: null, error: "Pawner details could not be loaded for screening. Please retry or check manually." });
    });
    return () => controller.abort();
  }, [receiptNo, enabled]);
  return enabled && state.receiptNo === receiptNo ? state : { customer: null, error: "" };
}
